import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { API } from '@/App';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import { divinationLabel } from '@/data/divination';
import { symbolOf } from '@/data/money';
import NotificationBell from '@/components/NotificationBell';

const AstrologerOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/orders`, { withCredentials: true });
        setOrders(res.data || []);
      } catch (error) {
        console.error('Error fetching orders:', error);
        toast.error('無法載入訂單');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <nav className="bg-white border-b border-[#E5E0D8] px-6 md:px-12 lg:px-24 py-4 flex justify-between items-center">
        <Link to="/astrologer/dashboard">
          <h2 className="text-xl font-serif text-[#C93B2B]">命理配對平台</h2>
        </Link>
        <NotificationBell />
      </nav>

      <div className="px-6 md:px-12 lg:px-24 py-12">
        <Link to="/astrologer/dashboard">
          <Button variant="ghost" className="mb-6 rounded-sm" data-testid="back-btn">
            <ArrowLeft className="w-4 h-4 mr-2" strokeWidth={1.5} />
            返回
          </Button>
        </Link>

        <div className="max-w-5xl mx-auto">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-serif text-[#1A1A1A] mb-2">
            我的訂單
          </h1>
          <p className="text-base text-[#5C5C5C] mb-8">
            已成交的諮詢，進入諮詢室與求測者聯絡
          </p>

          {loading ? (
            <div className="text-center py-12">
              <p className="text-[#5C5C5C]">載入中...</p>
            </div>
          ) : orders.length === 0 ? (
            <div className="bg-white border border-[#E5E0D8] rounded-sm p-12 text-center">
              <p className="text-sm text-[#5C5C5C]">尚未有成交訂單</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {orders.map((order) => (
                <div
                  key={order.order_id}
                  className="bg-white border border-[#E5E0D8] rounded-sm p-5 hover:shadow-md transition-shadow cursor-pointer flex flex-col"
                  onClick={() => navigate(`/chat/${order.order_id}`)}
                  data-testid={`order-card-${order.order_id}`}
                >
                  <div className="flex justify-between items-start mb-3">
                    <div className="inline-flex items-center border border-[#C93B2B] text-[#C93B2B] px-2 py-1 text-xs rounded-none font-serif tracking-widest">
                      {divinationLabel(order)}
                    </div>
                    <span className="text-xs text-[#5C5C5C]">
                      {symbolOf(order.currency)} {Number(order.amount).toLocaleString()}
                    </span>
                  </div>
                  <p className="text-sm text-[#1A1A1A] font-medium mb-1">
                    求測者：{order.other_party_name}
                  </p>
                  {order.client_subject_name && (
                    <p className="text-xs text-[#5C5C5C] mb-3">
                      占算對象：{order.client_subject_name}
                    </p>
                  )}
                  <p className="text-xs text-[#5C5C5C] mb-4">
                    成交時間：{new Date(order.paid_at).toLocaleString('zh-TW')}
                  </p>
                  <Button
                    variant="outline"
                    size="sm"
                    className="w-full rounded-sm border-[#C93B2B] text-[#C93B2B] hover:bg-[#F5F0E6] mt-auto"
                    data-testid={`enter-chat-${order.order_id}`}
                  >
                    <MessageCircle className="w-4 h-4 mr-2" strokeWidth={1.5} />
                    進入諮詢室
                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AstrologerOrders;
